export default "__VITE_ASSET__DxDuFpM5__"